import {ReactSVG} from "react-svg";
import { theme } from "../themes/theme";

export const LineOrIcon = () => {
    return (
        <div style={{display: "flex", alignItems: "center", color:theme.palette.text.primary, width: "100%"}}>
            <div style={{flexGrow: 1, borderBottom: `1px solid ${theme.palette.text.primary}`}}></div>
            <span style={{margin: "0 10px"}}>o</span>
            <div style={{flexGrow: 1, borderBottom: `1px solid  ${theme.palette.text.primary}`}}></div>
        </div>)
};